// Chrome now denies the 'unload' event by default (Permissions Policy), so registering a
// listener just logs "Permissions policy violation: unload is not allowed in this document"
// and the listener never runs. sockjs-client (latest 1.6.1) registers one at import time to
// tear down its transports. Redirect 'unload' listeners to 'pagehide', the recommended
// replacement. Skip persisted pagehides (page entering the back/forward cache): SockJS
// can't recover once its unload callbacks have fired, so it must only see a real unload.
// Must be imported before sockjs-client.
const wrappers = new WeakMap();
const origAdd = window.addEventListener;
const origRemove = window.removeEventListener;

const wrap = (listener) => {
    if (!wrappers.has(listener)) {
        wrappers.set(listener, function (e) {
            if (e.persisted) return;
            return typeof listener === 'function' ? listener.call(this, e) : listener.handleEvent(e);
        });
    }
    return wrappers.get(listener);
};

window.addEventListener = function (type, listener, options) {
    if (type === 'unload' && listener) return origAdd.call(this, 'pagehide', wrap(listener), options);
    return origAdd.call(this, type, listener, options);
};

window.removeEventListener = function (type, listener, options) {
    if (type === 'unload' && listener && wrappers.has(listener)) {
        return origRemove.call(this, 'pagehide', wrappers.get(listener), options);
    }
    return origRemove.call(this, type, listener, options);
};
